import { render, staticRenderFns } from "./NetWorthBars.vue?vue&type=template&id=0ab7b66e&scoped=true&"
import script from "./NetWorthBars.vue?vue&type=script&lang=js&"
export * from "./NetWorthBars.vue?vue&type=script&lang=js&"
import style0 from "./NetWorthBars.vue?vue&type=style&index=0&id=0ab7b66e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab7b66e",
  null
  
)

export default component.exports